import React, { useRef } from 'react';

import { AgGridReact } from 'ag-grid-react';

import CustomPagination from 'components/shared/CustomPagination/CustomPagination';

const LicenseSelectionTable = ({
  paginatedLicenses,
  columnDefs,
  defaultColDef,
  showPagination,
  currentPage,
  setCurrentPage,
  totalItems,
  pageSize
}) => {
  const gridRef = useRef(null);

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h3 className="text-lg font-semibold text-neutral-900">Select license</h3>
        <p className="text-sm text-neutral-600">
          Select the appropriate license for e-prescribing enrollment. If a license is missing or
          outdated, you can add a new one.
        </p>
      </div>

      <div className="w-full overflow-hidden rounded-lg border border-solid border-neutral-200">
        <div className="ag-theme-quartz w-full [&_.ag-center-cols-container]:!min-h-0 [&_.ag-center-cols-viewport]:!min-h-0">
          <AgGridReact
            ref={gridRef}
            rowData={paginatedLicenses}
            columnDefs={columnDefs}
            defaultColDef={defaultColDef}
            domLayout="autoHeight"
            suppressRowClickSelection={true}
            animateRows={true}
            suppressPaginationPanel={true}
          />
        </div>

        {showPagination && (
          <div className="flex items-center justify-end border-t border-neutral-200 bg-white px-4 py-2">
            <CustomPagination
              page={currentPage}
              perPage={pageSize}
              totalItems={totalItems}
              onPageChange={setCurrentPage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LicenseSelectionTable;
